import { Link as DsLink } from "@digdir/designsystemet-react";

interface LinkProps {
	children: React.ReactNode;
	href?: string;
	className?: string;
	size?: "sm" | "md" | "lg";
	color?: "primary" | "neutral";
	materialIconLeft?: string;
	materialIconRight?: string;
}

const Link = ({
	children,
	href,
	className = "",
	size = "md",
	color = "primary",
	materialIconLeft,
	materialIconRight,
	...props
}: LinkProps) => {
	const renderIcon = (icon: string) => (
		<span
			className="material-symbols-rounded inline align-middle text-[24px] group-hover:no-underline md:text-[28px] xl:text-[32px]"
			aria-hidden="true"
		>
			{icon}
		</span>
	);

	return (
		<DsLink
			href={href}
			className={`inline space-x-1.5 overflow-hidden no-underline group text-md ${className}`}
			data-color={color}
			data-size={size}
		>
			{materialIconLeft && renderIcon(materialIconLeft)}

			<span className="inline items-center space-x-1.5 underline decoration-1 text-balance group-hover:underline">
				{children}
			</span>

			{materialIconRight && renderIcon(materialIconRight)}
		</DsLink>
	);
};

export default Link;
